import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import { ButtonContained } from '../components/app-button/button'
import { withSnackbar } from 'notistack'
import cx from 'classnames'
import MChartDemo from '../components/MarketingDashboard/Demo/MChartDemo'
import MBarChartDemo from '../components/MarketingDashboard/Demo/MBarChartDemo'
import { thousandSeparator } from '../utils/Utils'
import { Rub } from '../components/app-icon/Icons'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import SwipeableViews from 'react-swipeable-views'
import MTabsDemo from '../components/MarketingDashboard/Demo/MTabsDemo'

function TabContainer({ children, dir }) {
  return (
    <Typography
      component="div"
      dir={dir}
      style={{ height: '100%', position: 'relative' }}
    >
      {children}
    </Typography>
  )
}

const styles = theme => ({
  dashboardWrap: {
    height: '100%',
    background: '#f8f8f8',
    paddingTop: 85,
    paddingBottom: 85,
  },
  dashboard: {
    paddingTop: 100,
  },
  appBar: {
    backgroundColor: '#8866FF',
  },
  paper: {
    backgroundColor: '#8866FF',
  },
  reportDialog: {
    backgroundColor: '#f8f8f8',
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  toolbarInner: {
    padding: 0,
  },
  reportDialogAppBar: {
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
  },
  logoRow: {
    '& a': {
      width: 80,
      height: 'auto',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '& div': {
      width: 50,
      '&:first-child': {
        height: 44,
      },
      '&:last-child': {
        height: 30,
      },
    },
  },
  appBarActions: {
    display: 'flex',
    alignItems: 'center',
  },
  appBarTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  mSettingBtn: {
    border: 0,
    outline: 'none',
    background: 'transparent',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  toggleCalendar: {
    position: 'relative',
    height: 40,
    fontSize: 16,
    padding: '0 40px 0 20px',
    whiteSpace: 'nowrap',
    lineHeight: 2.5,
    color: '#ffffff',
    marginRight: 25,
    '&:after': {
      content: "''",
      position: 'absolute',
      top: '50%',
      marginTop: -4,
      right: 16,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 4px 0 4px',
      borderColor: '#ffffff transparent transparent transparent',
    },
  },
  dateRangeWrapper: {
    width: 462,
    position: 'absolute',
    top: 75,
    right: 24,
    background: '#fff',
    boxShadow: '0px 12px 12px rgba(0,0,0,0.3)',
    borderRadius: 8,
    overflow: 'hidden',
  },
  backDropDateRange: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    WebkitTapHighlightColor: 'transparent',
  },
  overlayUpdate: {
    width: '100%',
    height: '100vh',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10000,
    position: 'fixed',
    touchAction: 'none',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    WebkitTapHighlightColor: 'transparent',
    overflow: 'hidden',
  },
  chartMulti: {
    position: 'relative',
    height: 0,
    margin: '0 10px 10px 10px',
    overflow: 'hidden',
    maxWidth: '100%',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    padding: '16px 20px',
    backgroundColor: '#fff',
    paddingBottom: '25%',
  },
  ripple: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    position: 'absolute',
    top: 'calc(50% - 30px)',
    left: 'calc(50% - 30px)',
    animationName: 'ripple',
    animationDuration: '1s',
    animationTimingFunction: 'ease-in-out',
    animationDirection: 'alternate-reverse',
    animationIterationCount: 'infinite',
    transform: 'scale(0)',
    opacity: 0.6,
  },
  ripple1: {
    backgroundColor: '#BEABFF',
  },
  ripple2: {
    animationDelay: '-250ms',
    backgroundColor: '#A68CFF',
  },
  ripple3: {
    animationDelay: '-500ms',
    backgroundColor: '#7C69BF',
  },
  ripple4: {
    animationDelay: '-750ms',
    backgroundColor: '#8866FF',
  },
  '@keyframes ripple': {
    to: { transform: 'scale(1)' },
  },
  grid: {
    margin: '0 5px',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '100%',
  },
  gridLargeItem: {
    width: '50%',
    display: 'flex',
    padding: 5,
    position: 'relative',
    '& $brick': {
      padding: '16px 5px 12px 5px',
      width: '100%',
      height: 0,
      paddingBottom: '37.25%',
    },
  },
  gridSmallItem: {
    display: 'flex',
    width: '25%',
    minWidth: 305,
    padding: '5px',
    '& $brick': {
      width: '100%',
      height: 0,
      paddingBottom: '68%',
    },
  },
  gridFullItem: {
    display: 'flex',
    width: '100%',
    minWidth: 305,
    padding: '5px',
    '& $brick': {
      width: '100%',
      height: 0,
      paddingBottom: '28%',
    },
  },
  brick: {
    position: 'relative',
    padding: '20px',
    borderRadius: '8px',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    flex: '1 1 auto',
  },
  brickTitle: {
    fontSize: 16,
  },
  brickSubTitle: {
    display: 'block',
    fontSize: '12px',
  },
  brickTotal: {
    fontSize: '23px',
    whiteSpace: 'nowrap',
  },
  chartBox: {
    marginTop: 35,
    position: 'absolute',
    left: 10,
    right: 20,
    top: 50,
    bottom: 15,
  },
  conversionTitle: {
    display: 'block',
    textTransform: 'none',
  },
  conversionTotal: {
    display: 'block',
    fontSize: 23,
    lineHeight: 1.2,
  },
  tabsRoot: {
    marginTop: 10,
  },
  tabSlide: {},
  brickTitleBig: {
    textAlign: 'center',
    fontSize: 20,
  },
  rowTitle: {
    width: '100%',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    backgroundColor: '#fff',
    margin: 5,
    padding: 20,
  },
  tabsFlexContainer: {
    justifyContent: 'center',
  },
  rowCharts: {
    width: '100%',
    display: 'flex',
    '& $brick': {
      paddingBottom: '52%',
    },
    '& $chartBox': {
      marginTop: 85,
    },
  },
  noData: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -100%)',
    fontSize: 40,
    color: 'rgba(0, 0, 0, 0.4)',
  },
  subRowCharts: {
    listStyleType: 'none',
    padding: 0,
    marginTop: 20,
    marginBottom: 10,
    display: 'flex',
    justifyContent: 'space-around',
  },
  subRowChartsItems: {
    flex: 1,
  },
  subRowChartsItemsHead: {
    display: 'block',
    textAlign: 'center',
    fontSize: 14,
  },
  subRowChartsItemsTotal: {
    display: 'block',
    textAlign: 'center',
    fontSize: 28,
  },
})

class ReportDailyDemo extends Component {
  state = {
    data: {},
    chartData: null,
    columns: {},
    summaryData: {},
    site: window.state.site,
    startDate: '',
    endDate: '',
    overlayUpdateOpen: false,
    valueTab: 0,
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    this.setState({
      overlayUpdateOpen: true,
    })

    let url = '/reports/daily/demo';

    const options = () => ({
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options())
      .then(handleResponse)
      .then(data => {
        this.setState({
          overlayUpdateOpen: false,
          data,
          startDate: data.fromDate,
          endDate: data.toDate,
        })
      })
      .catch(errors)
  }

  handleChangeTab = (event, valueTab) => {
    this.setState({ valueTab })
  }

  handleChangeIndex = index => {
    this.setState({ valueTab: index })
  }

  render() {
    const {
      startDate,
      endDate,
      overlayUpdateOpen,
      site,
      valueTab,
    } = this.state
    const { summary, conversions, orders, leads, calls } = this.state.data
    const { classes, theme } = this.props

    const Project = () => (
      <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
        <div className={classes.siteIcon}>S</div>
        <ul className={classes.info}>
          <Typography component="li" variant="body1">
            {site.url}
          </Typography>
          <Typography component="li" variant="overline">
            {site.name}
          </Typography>
        </ul>
      </a>
    )

    const chartsSummaryGrid = () =>
      summary.map(({ alias, total, chartByDaysData }, index) => {
        const title = () => {
          switch (alias) {
            case 'cost':
              return 'Расходы на рекламу'
            case 'impressions':
              return 'Число показов'
            case 'sessions':
              return 'Сеансы'
            case 'cpc':
              return 'CPC'
            default:
              return
          }
        }

        return (
          <div className={classes.gridSmallItem} key={alias}>
            <div className={classes.brick}>
              <div className={classes.brickTitle}>{title()}</div>
              <div className={classes.brickTotal}>
                {thousandSeparator(total)}
                {index === 0 || index === 3 ? (
                  <Rub width={30} height={16} />
                ) : null}
              </div>
              <div className={classes.chartBox}>
                <MChartDemo
                  label={title()}
                  data={chartByDaysData}
                  showGridline
                  fill
                  showGridline
                  gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                  zeroLineColor={'#979797'}
                  fontColor={'#000000'}
                  chartColor={'#8866ff'}
                  symbol={index === 0 || index === 3 ? '₽' : ''}
                  chartColorFill={'rgba(136, 102, 255, 0.2)'}
                  verticalLineColor={'#8866ff'}
                />
              </div>
            </div>
          </div>
        )
      })

    const bookMarks = () => {
      return conversions.map(({ alias, name, total }) => {
        const tabName = () => {
          switch (alias) {
            case 'leads':
              return name ? name : 'Заявки'
            case 'leads2':
              return name ? name : 'Заявки'
            case 'leads3':
              return name ? name : 'Заявки'
            case 'calls':
              return name ? name : 'Звонки'
            case 'calls2':
              return name ? name : 'Звонки'
            case 'calls3':
              return name ? name : 'Звонки'
            case 'orders':
              return name ? name : 'Продажи'
            default:
              return
          }
        }
        const label = (
          <span>
            <span className={classes.conversionTitle}>{tabName()}</span>
            <span className={classes.conversionTotal}>{total}</span>
          </span>
        )

        return <Tab key={alias} label={label} />
      })
    }

    const bookMarksContainer = () => {
      return conversions.map(({ alias, name, chartByDaysData }) => {
        const tabName = () => {
          switch (alias) {
            case 'leads':
              return name ? name : 'Заявки'
            case 'leads2':
              return name ? name : 'Заявки'
            case 'leads3':
              return name ? name : 'Заявки'
            case 'calls':
              return name ? name : 'Звонки'
            case 'calls2':
              return name ? name : 'Звонки'
            case 'calls3':
              return name ? name : 'Звонки'
            case 'orders':
              return name ? name : 'Продажи'
            default:
              return
          }
        }
        return (
          <TabContainer key={alias} dir={theme.direction}>
            <MChartDemo
              label={tabName()}
              data={chartByDaysData}
              showGridline
              gridLinesColor={'rgba(0, 0, 0, 0.2)'}
              zeroLineColor={'#979797'}
              fontColor={'#000000'}
              chartColor={'#8866ff'}
              chartColorFill={'rgba(136, 102, 255, 0.2)'}
            />
          </TabContainer>
        )
      })
    }

    const leadsTabs = () => {
      return leads.map(({ name, data, chartBySourcesData }) => {
        const tabs = data.map(({ alias, total }, index) => {
          const tabName = () => {
            switch (alias) {
              case 'total':
                return 'Кол-во'
              case 'conversion':
                return 'Конвесия'
              case 'cpa':
                return 'Цена'
              default:
                return
            }
          }

          const symbol = () => {
            switch (index) {
              case 0:
                return ''
              case 1:
                return '%'
              case 2:
                return <Rub width={30} height={16} />
              default:
                return
            }
          }

          const label = (
            <span>
              <span className={classes.conversionTitle}>{tabName()}</span>
              <span className={classes.conversionTotal}>
                {thousandSeparator(total)}
                {symbol()}
              </span>
            </span>
          )

          return <Tab key={alias} label={label} />
        })

        const container = data.map(({ alias, chartByPeriodData }, index) => {
          const tabName = () => {
            switch (alias) {
              case 'total':
                return 'Кол-во'
              case 'conversion':
                return 'Конвесия'
              case 'cpa':
                return 'Цена'
              default:
                return
            }
          }

          const symbol = () => {
            switch (index) {
              case 0:
                return ''
              case 1:
                return '%'
              case 2:
                return '₽'
              default:
                return
            }
          }

          return (
            <TabContainer key={alias} dir={theme.direction}>
              <MChartDemo
                label={tabName()}
                data={chartByPeriodData}
                showGridline
                gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                zeroLineColor={'#979797'}
                fontColor={'#000000'}
                chartColor={'#8866ff'}
                chartColorFill={'rgba(136, 102, 255, 0.2)'}
                symbol={symbol()}
              />
            </TabContainer>
          )
        })

        return (
          <div key={name} className={classes.rowCharts}>
            <div className={classes.gridLargeItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitle}>
                  {name ? name : 'Заявки'}
                </div>
                <MTabsDemo tabs={tabs} container={container} />
              </div>
            </div>
            <div className={classes.gridLargeItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitle}>
                  {name ? name : 'Заявки'}
                </div>
                <div className={classes.chartBox} style={{ marginTop: 0 }}>
                  {chartBySourcesData && chartBySourcesData.length > 0 ? (
                    <MBarChartDemo
                      label={name ? name : 'Заявки'}
                      data={chartBySourcesData}
                      showGridline
                      showLegend
                      gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                      zeroLineColor={'#979797'}
                      fontColor={'#000000'}
                      limitTicks={7}
                    />
                  ) : (
                    <span className={classes.noData}>Нет данных</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      })
    }

    const callsTabs = () => {
      return calls.map(({ name, data, chartBySourcesData }) => {
        const tabs = data.map(({ alias, total }, index) => {
          const tabName = () => {
            switch (alias) {
              case 'total':
                return 'Кол-во'
              case 'conversion':
                return 'Конвесия'
              case 'cpa':
                return 'Цена'
              default:
                return
            }
          }

          const symbol = () => {
            switch (index) {
              case 0:
                return ''
              case 1:
                return '%'
              case 2:
                return <Rub width={30} height={16} />
              default:
                return
            }
          }

          const label = (
            <span>
              <span className={classes.conversionTitle}>{tabName()}</span>
              <span className={classes.conversionTotal}>
                {thousandSeparator(total)}
                {symbol()}
              </span>
            </span>
          )

          return <Tab key={alias} label={label} />
        })

        const container = data.map(({ alias, chartByPeriodData }, index) => {
          const tabName = () => {
            switch (alias) {
              case 'total':
                return 'Кол-во'
              case 'conversion':
                return 'Конвесия'
              case 'cpa':
                return 'Цена'
              default:
                return
            }
          }

          const symbol = () => {
            switch (index) {
              case 0:
                return ''
              case 1:
                return '%'
              case 2:
                return '₽'
              default:
                return
            }
          }

          return (
            <TabContainer key={alias} dir={theme.direction}>
              <MChartDemo
                label={tabName()}
                data={chartByPeriodData}
                showGridline
                gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                zeroLineColor={'#979797'}
                fontColor={'#000000'}
                chartColor={'#8866ff'}
                chartColorFill={'rgba(136, 102, 255, 0.2)'}
                symbol={symbol()}
              />
            </TabContainer>
          )
        })

        return (
          <div key={name} className={classes.rowCharts}>
            <div className={classes.gridLargeItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitle}>
                  {name ? name : 'Звонки'}
                </div>
                <MTabsDemo tabs={tabs} container={container} />
              </div>
            </div>
            <div className={classes.gridLargeItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitle}>
                  {name ? name : 'Звонки'}
                </div>
                <div className={classes.chartBox} style={{ marginTop: 0 }}>
                  {chartBySourcesData && chartBySourcesData.length > 0 ? (
                    <MBarChartDemo
                      label={name ? name : 'Звонки'}
                      data={chartBySourcesData}
                      showGridline
                      showLegend
                      gridLinesColor={'rgba(0, 0, 0, 0.2)'}
                      zeroLineColor={'#979797'}
                      fontColor={'#000000'}
                      limitTicks={7}
                    />
                  ) : (
                    <span className={classes.noData}>Нет данных</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      })
    }

    return (
      <div className={classes.dashboardWrap}>
        {overlayUpdateOpen && (
          <div className={classes.overlayUpdate}>
            <div className={classes.loading}>
              <div className={cx(classes.ripple, classes.ripple1)}></div>
              <div className={cx(classes.ripple, classes.ripple2)}></div>
              <div className={cx(classes.ripple, classes.ripple3)}></div>
              <div className={cx(classes.ripple, classes.ripple4)}></div>
            </div>
          </div>
        )}

        <AppBar className={classes.reportDialogAppBar} elevation={0}>
          <Toolbar
            style={{
              maxWidth: '100%',
              margin: '0 auto',
              width: '100%',
              height: 80,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 10px',
            }}
          >
            <div className={classes.appBarTitle}>
              <LogoData customClass={classes.logoRow} />
              <Project />
            </div>

            <ButtonContained
              href="https://cabinet.romi.center/register?utm_source=demo_dashboard&utm_medium=button&utm_campaign=demo"
              customClass={classes.toggleCalendar}
              color="secondary"
              text="Попробовать бесплатно"
            />
          </Toolbar>
        </AppBar>

        <div className={classes.grid}>
          {summary && summary.length > 0 && chartsSummaryGrid()}

          {conversions && conversions.length > 0 && (
            <div className={classes.gridFullItem}>
              <div className={classes.brick}>
                <div className={classes.brickTitleBig}>Конверсии</div>
                <AppBar position="static" color="inherit" elevation={0}>
                  <Tabs
                    value={valueTab}
                    onChange={this.handleChangeTab}
                    indicatorColor="secondary"
                    textColor="inherit"
                    variant="scrollable"
                    scrollButtons="off"
                    classes={{
                      root: classes.tabsRoot,
                      indicator: classes.tabsIndicator,
                      flexContainer: classes.tabsFlexContainer,
                    }}
                  >
                    {bookMarks()}
                  </Tabs>
                </AppBar>
                <SwipeableViews
                  axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                  index={valueTab}
                  onChangeIndex={this.handleChangeIndex}
                  slideClassName={classes.tabSlide}
                  containerStyle={{
                    height: '100%',
                  }}
                  style={{
                    top: 160,
                    left: 10,
                    right: 20,
                    bottom: 15,
                    position: 'absolute',
                  }}
                >
                  {bookMarksContainer()}
                </SwipeableViews>
              </div>
            </div>
          )}

          {orders && orders.length > 0 && (
            <Fragment>
              <div className={classes.rowTitle}>
                <div className={classes.brickTitleBig}>Продажи</div>
              </div>
              <div className={classes.gridSmallItem}>
                <div
                  className={classes.brick}
                  style={{
                    paddingBottom: '23.25%',
                    backgroundColor: '#8866ff',
                  }}
                >
                  <div className={classes.brickDescription}>
                    <div
                      className={classes.brickTitle}
                      style={{ color: '#fff' }}
                    >
                      Оплаты
                    </div>
                    <div
                      className={classes.brickTotal}
                      style={{ fontSize: 33, color: '#fff' }}
                    >
                      {thousandSeparator(orders[0].total)}
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.gridSmallItem}>
                <div
                  className={classes.brick}
                  style={{
                    paddingBottom: '23.25%',
                    backgroundColor: '#8866ff',
                  }}
                >
                  <div className={classes.brickDescription}>
                    <div
                      className={classes.brickTitle}
                      style={{ color: '#fff' }}
                    >
                      Выручка
                    </div>
                    <div
                      className={classes.brickTotal}
                      style={{ fontSize: 33, color: '#fff' }}
                    >
                      {thousandSeparator(orders[0].revenue)}
                      <Rub width={26} height={22} fill={'#fff'} />
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.gridSmallItem}>
                <div
                  className={classes.brick}
                  style={{
                    paddingBottom: '23.25%',
                    backgroundColor: '#8866ff',
                  }}
                >
                  <div className={classes.brickDescription}>
                    <div
                      className={classes.brickTitle}
                      style={{ color: '#fff' }}
                    >
                      CPO
                    </div>
                    <div
                      className={classes.brickTotal}
                      style={{ fontSize: 33, color: '#fff' }}
                    >
                      {thousandSeparator(orders[0].cpo)}
                      <Rub width={26} height={22} fill={'#fff'} />
                    </div>
                  </div>
                </div>
              </div>
              <div className={classes.gridSmallItem}>
                <div
                  className={classes.brick}
                  style={{
                    paddingBottom: '23.25%',
                    backgroundColor: '#8866ff',
                  }}
                >
                  <div className={classes.brickDescription}>
                    <div
                      className={classes.brickTitle}
                      style={{ color: '#fff' }}
                    >
                      ROMI
                    </div>
                    <div
                      className={classes.brickTotal}
                      style={{ fontSize: 33, color: '#fff' }}
                    >
                      {thousandSeparator(orders[0].romi)} %
                    </div>
                  </div>
                </div>
              </div>
              <div key={name} className={classes.rowCharts}>
                <div className={classes.gridLargeItem}>
                  <div
                    className={classes.brick}
                    style={{
                      backgroundColor: '#8866ff',
                    }}
                  >
                    <div
                      className={classes.brickTitle}
                      style={{ color: '#fff' }}
                    >
                      {orders[0].name ? orders[0].name : 'Продажи'}
                    </div>
                    <div className={classes.chartBox} style={{ marginTop: 0 }}>
                      <MChartDemo
                        label={orders[0].name ? orders[0].name : 'Продажи'}
                        data={orders[0].chartByPeriodData}
                        showGridline
                        showLegend={false}
                        fill
                        gridLinesColor={'#ffffff'}
                        zeroLineColor={'#ffffff'}
                        fontColor={'#ffffff'}
                        chartColor={'#ffcc00'}
                        labelFontColor={'#ffffff'}
                        chartColorFill={'rgba(255, 204, 0, 0.2)'}
                        verticalLineColor={'#ffcc00'}
                      />
                    </div>
                  </div>
                </div>
                <div className={classes.gridLargeItem}>
                  <div
                    className={classes.brick}
                    style={{
                      backgroundColor: '#8866ff',
                    }}
                  >
                    <div
                      className={classes.brickTitle}
                      style={{ color: '#fff' }}
                    >
                      {orders[0].name ? orders[0].name : 'Продажи'}
                    </div>
                    <div className={classes.chartBox} style={{ marginTop: 0 }}>
                      {orders[0].chartBySourcesData &&
                      orders[0].chartBySourcesData.length > 0 ? (
                        <MBarChartDemo
                          label={orders[0].name ? orders[0].name : 'Продажи'}
                          data={orders[0].chartBySourcesData}
                          showGridline
                          showLegend
                          fill={false}
                          gridLinesColor={'#ffffff'}
                          zeroLineColor={'#ffffff'}
                          fontColor={'#ffffff'}
                          chartColor={'#ffcc00'}
                          labelFontColor={'#ffffff'}
                          chartColorFill={'#ffcc00'}
                          limitTicks={7}
                        />
                      ) : (
                        <span
                          className={classes.noData}
                          style={{ color: '#fff' }}
                        >
                          Нет данных
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          )}

          {leads && leads.length > 0 && (
            <Fragment>
              <div className={classes.rowTitle}>
                <div className={classes.brickTitleBig}>Заявки</div>
              </div>

              {leads && leads.length > 0 && leadsTabs()}
            </Fragment>
          )}

          {calls && calls.length > 0 && (
            <Fragment>
              <div className={classes.rowTitle}>
                <div className={classes.brickTitleBig}>Звонки</div>
              </div>

              {calls && calls.length > 0 && callsTabs()}
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(
  withSnackbar(ReportDailyDemo)
)
